import { scrollThin } from "../../styles/g-grid-v2/components/scrollbarSelect";
const customHeight = "23px";

const customStyle = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: state.isDisabled ? "light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))" : "#fff",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: state.selectProps.error ? "red" : "gray",
    "&:hover": {
      borderColor: state.selectProps.error ? "red" : "gray",
    },
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
    padding: "0 6px",
    fontSize: 11,
    color: "#333"
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: '#333',
    fontWeight: "normal",
    fontFamily: "Arial",
    fontSize: "12px",
    padding: "1.5px 0"
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    padding: "0px",
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
  }),

  clearIndicator: (provided: any, state: any) => ({
    ...provided,
    svg: {
      height: "23px"
    }
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : "",
    whiteSpace: "normal",
  }),

  placeholder: (provided: any, state: any) => ({
    ...provided,
    display: "block",
    color: "#C0C0C0"
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  })
};

const customStyleClassic = {
  ...customStyle,
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: "none"
  }),
  menuPortal: (provided: any, state: any) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const customStyleForModal = {
  ...customStyle,
  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 7,
    border: "none",
    boxShadow: state.isFocused ? null : null,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: "none"
  }),
};

const customSolidBorder = {
  ...customStyleClassic,
  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: state.selectProps.error ? "red" : "gray",
    boxShadow: state.isFocused ? null : null,
  }),
}

const rowInMainTable = {
  ...customStyleClassic,
  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    minHeight: 16,
    height: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: state.selectProps.error ? "red" : "gray",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: 16,
    padding: "0 0",
    color: "#333",
    margin: "0 0 auto 2px",
    textAlign: "left"
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    height: 14,
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    fontSize: "11px"
  }),

}

const rowInMainTableNoBorder = {
  ...rowInMainTable,
  control: (provided: any, state: any) => ({
    ...provided,
    border: 'none',
    boxShadow: 'none',
    height: 16,
    minHeight: 16,
  }),
}

export const styles = {
  customStyleClassic,
  customStyleForModal,
  customStyle,
  customSolidBorder,
  rowInMainTable,
  rowInMainTableNoBorder
};
